/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as marqueeService from '../services/marqueeService'
import Toast from './sub_components/toast';
class MarqueeSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      marquee:"",
      toastMsg: "",
      toastType: "",
      showToast: false
    };
  }
  showToast(msg, type) {
    let self = this
    this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
        setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
        }, 3000);
    })
  }  
  componentDidMount(){
    // marqueeService.getMarquee().then((res)=>{
    //     if(!!res && !!res.exception.message){
    //       this.setState({marquee:res.exception.message})
    //     }
    //   })
  }
  addMarquee(){
    marqueeService.addMarquee({"message":this.state.marquee}).then((res)=>{
      if(!!res && res.isSuccess){
        this.props.notify("Marquee Successfully Updated","success")
      }
    })
  }
  render() {
    return (
      <body className="bethubs">
        <Header history = {this.props.history} />
        <div className="wrapper">
          <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                <ul className="list-unstyled collapse" id="homeSubmenu" >
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                <ul className="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="container-fluid container-padding-0">
            <div className="row">
               <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="main-box">
                     <h5 className="text-blue">Marquee Settings</h5>
                     <div style={{textAlign:"center"}}>
                        <textarea rows={8} className="form-control" value={this.state.marquee} onChange={(e)=>{this.setState({marquee:e.target.value})}} />
                        <button className="btn btn-blue mt-2" onClick={()=>{this.addMarquee()}}>Update Marquee</button>
                      </div>
                     </div>
                  </div>
               </div>
            </div>
        </div>
        {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
        <Footer />
      </body>
    )
  }
}
function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MarqueeSettings);